export function gup(name: string): string | null {
  const url = window.location.href;
  // eslint-disable-next-line require-unicode-regexp
  const tenantName = name.replace(/\[/u, '\\[').replace(/]/, '\\]');
  const regexS = `[\\?&]${tenantName}=([^&#]*)`;
  // eslint-disable-next-line require-unicode-regexp
  const regex = new RegExp(regexS);
  const results = regex.exec(url);
  return results === null ? null : results[1];
}
